import { createContext, useContext, useState, useEffect } from 'react';
import { Howl } from 'howler';

const AudioContext = createContext(null);

export function AudioProvider({ children }) {
  const [isReady, setIsReady] = useState(false);
  const [sounds, setSounds] = useState(null);

  useEffect(() => {
    const soundsConfig = {
      list: new Howl({
        src: ['/sounds/list.m4a'],
        volume: 0.8,
        // html5: true,
        onload: () => console.log('list sound loaded'),
        onloaderror: (id, err) => console.error('Error loading list sound:', err)
      }),
      button: new Howl({
        src: ['/sounds/button.mp3'],
        volume: 0.3,
        // html5: true,
        onload: () => console.log('button sound loaded'),
        onloaderror: (id, err) => console.error('Error loading button sound:', err)
      }),
      music: new Howl({
        src: ['/sounds/every1loop.mp3'],
        volume: 0.3,
        // html5: true,
        loop: true,
        onload: () => console.log('music loaded'),
        onloaderror: (id, err) => console.error('Error loading music:', err)
      })
    };

    setSounds(soundsConfig);
    setIsReady(true);

    // Cleanup beim Unmount
    return () => {
      Object.values(soundsConfig).forEach(sound => {
        sound.stop();
        sound.unload();
      });
    };
  }, []);

  const playSound = (soundName) => {
    if (!sounds?.[soundName]) {
      console.warn(`Sound "${soundName}" not found`);
      return;
    }
    try {
      sounds[soundName].play();
    } catch (err) {
      console.error(`Error playing ${soundName}:`, err);
    }
  };

  const stopSound = (soundName) => {
    if (!sounds?.[soundName]) {
      console.warn(`Sound "${soundName}" not found`);
      return;
    }
    try {
      sounds[soundName].pause();
    } catch (err) {
      console.error(`Error stopping ${soundName}:`, err);
    }
  };

  if (!isReady) {
    console.log('Audio system initializing...');
    return null;
  }

  return (
    <AudioContext.Provider 
      value={{
        playSound,
        stopSound,
        isPlaying: (name) => sounds?.[name]?.playing() || false
      }}
    >
      {children}
    </AudioContext.Provider>
  );
}

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    console.warn('useAudio must be used within an AudioProvider');
    return {
      playSound: () => {},
      stopSound: () => {},
      isPlaying: () => false
    };
  }
  return context;
};